import AppCatalog from "../../services/App/AppCatalog.js";
import AppModule from "../../services/App/AppModule.js";
import Catalog from "./ExpCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari " + Catalog.ExpenseNumber.Label,
    Type: AppCatalog.Field.Search.Type,
    MaxLength: AppCatalog.Field.Search.MaxLength,
    Param: AppCatalog.Field.Search.Param
  },

  Date: {
    Label: Catalog.Date.Label,
    Type: Catalog.Date.Type,
    IsRange: true,
    Required: true,
    RequiredHide: true,
    Param: AppCatalog.Field.Date.Param
  },
  PaymentTypeName: {
    Label: Catalog.PaymentTypeName.Label,
    Type: Catalog.PaymentTypeName.Type,
    Input: Catalog.PaymentTypeName.Input,
    Param: AppModule.PaymentType.Param
  },
  SubCategoryID: {
    Label: Catalog.SubCategoryID.Label,
    Type: Catalog.SubCategoryID.Type,
    Input: Catalog.SubCategoryID.Input,
    Param: AppModule.ExpenseCategory.Param + AppCatalog.Field.ID.Param
  },
  WarehouseID: {
    Label: Catalog.WarehouseID.Label,
    Type: Catalog.WarehouseID.Type,
    Input: Catalog.WarehouseID.Input,
    Param: AppModule.Warehouse.Param + AppCatalog.Field.ID.Param
  }
}